import type { JobFormRateValues } from "@js/types/jobs";

type RateFieldKey = keyof JobFormRateValues | "job_type";
export const RATE_FIELDS_KEYS = {
  hourly_rate: "hourly_rate",
  payment_type: "payment_type",
  fixed_rate: "fixed_rate",
  min_rate: "min_rate",
  max_rate: "max_rate",
  min_annual_rate: "min_annual_rate",
  max_annual_rate: "max_annual_rate",
  job_type: "job_type",
  custom_min_rate: "custom_min_rate",
  custom_max_rate: "custom_max_rate",
  min_monthly_rate: "min_monthly_rate",
  max_monthly_rate: "max_monthly_rate",
  talent_invoice_editing_disabled: "talent_invoice_editing_disabled",
} as const satisfies Record<RateFieldKey, RateFieldKey>;
